import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { BehaviorSubject, from, Observable, throwError } from "rxjs";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { switchMap, catchError } from "rxjs/operators";
import { AuthService } from "../services/auth.service";
import { NotificationToastService } from "../services/notification-toast.service";

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  private isRefreshingToken = false;
  private tokenSubject = new BehaviorSubject<string | null>(null);

  constructor(
    private authService: AuthService,
    private router: Router,
    private notificationToastService: NotificationToastService,
  ) {}

  private isRefreshTokenRequest(req: HttpRequest<any>): boolean {
    return req.url.includes("/authentication/RefreshToken");
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {

    if (this.isRefreshTokenRequest(req)) {
      return next.handle(this.addHeaders(req, this.authService.getToken()))
        .pipe(catchError(err => this.handleError(err)));
    }

    return from(this.authService.getValidToken()).pipe(
      switchMap(token =>
        next.handle(this.addHeaders(req, token))
          .pipe(catchError(err => this.handleError(err)))
      ),
    );
  }

  private addHeaders(req: HttpRequest<any>, token: string): HttpRequest<any> {
    let headers = req.headers.set("Content-Type", "application/json");

    if (token) {
      headers = headers.set("Authorization", `Bearer ${token}`);
    }

    return req.clone({ headers });
  }

  private handleError(err: any): Observable<never> {
    if (err instanceof HttpErrorResponse) {

      if (err.status === 412) {
        this.notificationToastService.error(
          "Está usando una versión desactualizada del sistema",
          "Seguridad",
        );
      }

      if (err.status === 401 || err.status === 403) {
        this.notificationToastService.error(
          "No se encuentra autorizado para realizar la acción solicitada",
          "Seguridad",
        );
        this.authService.logOut();
        this.router.navigate(["login"]);
      }

      return throwError(err);
    }

    return throwError(err);
  }
}
